// src/components/RulingRef.js
//
// RULING 168 (2026-09-17): the one component that puts a ruling number on a screen. An officer gets
// the end-of-line tag "[R-nn]"; a member gets a small "Why?" that opens the plain-language reason with
// the number inside it. The decision is src\data\rulingRef.js's; this only draws.
//
//   <RulingRef user={user} n={17} why="Only invitees may be present in the meeting room." />
import React, { useState, useRef, useEffect } from 'react';
import { refMode, rulingTag, whyText } from '../data/rulingRef';

export default function RulingRef({ user, n, why }) {
  const [open, setOpen] = useState(false);
  const box = useRef(null);
  // Greg's note #1 (10/4): a tap or click anywhere outside the pop-over closes it; so does Escape.
  useEffect(() => {
    if (!open) return undefined;
    const away = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    const esc = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', away); document.addEventListener('touchstart', away); document.addEventListener('keydown', esc);
    return () => { document.removeEventListener('mousedown', away); document.removeEventListener('touchstart', away); document.removeEventListener('keydown', esc); };
  }, [open]);
  if (refMode(user) === 'tag') {
    const tag = rulingTag(user, n);
    return tag ? <span style={{ marginLeft: 6, fontSize: 11, color: '#4A6280', whiteSpace: 'nowrap' }}>{tag}</span> : null;
  }
  const text = whyText(n, why);
  if (!text) return null;
  return (
    <span ref={box} style={{ position: 'relative', marginLeft: 6, whiteSpace: 'nowrap' }}>
      <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open}
        style={{ background: 'none', border: '1px solid #2E4A6B', borderRadius: 10, color: '#8AA4BF', fontSize: 11, padding: '0 8px', cursor: 'pointer' }}>
        Why?
      </button>
      {open ? (
        <span role="dialog" style={{ position: 'absolute', zIndex: 20, top: '120%', left: 0, minWidth: 240, maxWidth: 360, whiteSpace: 'normal', background: '#0D1B2A', border: '1px solid #2E4A6B', borderRadius: 8, padding: '8px 10px', fontSize: 12, color: '#DCE7F2', boxShadow: '0 4px 16px rgba(0,0,0,0.4)' }}>
          {text}
        </span>
      ) : null}
    </span>
  );
}
